import { PreviewServiceBlock } from "@/payload-types";
import Service from "./Service";
import Card from "./Card";

const Services: React.FC<PreviewServiceBlock> = (data) => {
  const { title, selectedPages } = data;

  return title ? (
    <div className="bg-white xsmall:py-20 lg:py-16">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-10 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          <div>
            <p className="font-display tracking-tight text-gray-900 xsmall:text-2xl md:text-5xl">
              {title}
            </p>
          </div>
          <dl className="col-span-2 grid grid-cols-1 gap-x-8 gap-y-16 sm:grid-cols-2">
            {selectedPages &&
              selectedPages.map((service) => (
                <Service key={service.id} service={service} />
              ))}
          </dl>
        </div>
      </div>
    </div>
  ) : (
    <div className="mx-auto flex max-w-7xl flex-wrap justify-center gap-4 xsmall:py-20 lg:py-16">
      {selectedPages &&
        selectedPages.map((service) => (
          <Card key={service.id} service={service} />
        ))}
    </div>
  );
};

export default Services;
